import { chevronLeft } from './chevronLeft';

export const chevronDown = () => chevronLeft({
  transform: 'rotate(-90 4 6)',
});
